import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { ModalLayout } from '@appbase/templates'
import { MultilineTextBoxField, TextBoxField, FormGroup } from '@appbase/components/forms'
import api from '@webparts/api'
import { getGUID } from '@appbase/util'
import GridView from '@appbase/components/GridView/GridView.vue'

@Component({
    components: {
        ModalLayout,
        TextBoxField,
        FormGroup,
        GridView,
        MultilineTextBoxField
    },
})
export default class BannerSettingModal extends Vue {
    @Prop({ type: String }) comCode!: string
    @Prop({ type: Boolean, default: false }) isGlobalBanner!: boolean
    @Prop({ type: String, default: null }) mappingId!: string

    banners: gridView.ModelItem<webpartBanner.Banner>[] = []
    curBanner: webpartBanner.Banner = this.setBannerInitVal()
    bannerSetting: boolean = false
    headers: Array<gridView.Header> = [
        { displayName: this.$t('카테고리').toString(), rowKey: 'category', width: '100' },
        { displayName: this.$t('제목').toString(), rowKey: 'title', width: '120' },
        { displayName: this.$t('표시날짜').toString(), rowKey: 'inputDate', width: '100' },
        { displayName: '', rowKey: '', slotName: 'order', width: '40', align: 'center' },
        { displayName: '', rowKey: '', slotName: 'edit', width: '60' },
    ]
    selectedBanners: webpartBanner.Banner[] = []
    canSetOrder: boolean = true
    fileDelete: boolean = false

    handleClose() {
        this.closeCurrentModal()
    }

    created() {
        this.loadBannerList()
    }

    loadBannerList() {
        api.webpartBanner.getBannerList(this.comCode, this.isGlobalBanner, this.mappingId).then(res => {
            if (res && res.length > 0) {
                res.forEach((r) => {
                    r.linkUrl = decodeURIComponent(r.linkUrl);
                });
                
                this.banners = res
            }
        })
    }

    // 배너 초기값
    setBannerInitVal(order?: number) {
        this.fileDelete = false
        return {
            comcode: this.comCode,
            category: "",
            title: "",
            linkUrl: "",
            inputDate: "",
            listOrder: order ? order : 0,
            useStatus: true,
            fileName: '',
            filePath: '',
            savedFileName: '',
            fileSize: 0,
            createUser: '',
            createdDate: new Date(),
            isGlobal: this.isGlobalBanner,
            mappingId: this.isGlobalBanner ? null : this.mappingId
        }
    }

    // banner 이미지파일 추가/제거
    fnFileSelect() {
        let elem = document.createElement("input");
        elem.id = 'image';
        elem.type = 'file';
        elem.accept = 'image/*';
        elem.multiple = false;
        elem.click();

        elem.onchange = this.fnUploadFile;
    }

    fnUploadFile(ev: any) {
        if (ev.currentTarget && ev.currentTarget.files) {
            let fileCode = "SYSTEM_WEBPART_BANNER" + getGUID(true);
            let fileName = ev.currentTarget.files[0].name;
            let savedFileName = fileCode + fileName.substring(fileName.lastIndexOf('.'))
            let fileSize = ev.currentTarget.files[0].size;
            const formData = new FormData();
            formData.append('Code', fileCode);
            formData.append('CodeValues', "SYSTEM,BANNER");
            formData.append("File", ev.currentTarget.files[0], savedFileName);

            api.webpartBanner.uploadFile(formData).then((res) => {
                this.curBanner.fileName = fileName;
                this.curBanner.savedFileName = savedFileName;
                this.curBanner.filePath = '/cm/File/Download?filename=' + savedFileName + '&code=' + fileCode;
                this.curBanner.fileSize = fileSize;
            }).catch((error) => {
                (window as any).alertAsync(this.$t('파일_업로드_실패').toString());
            })
                .finally(() => {
                });
        }
    }

    fnDeleteFile() {
        if (this.curBanner.filePath) {
            let savedFileName = this.curBanner.savedFileName;
            let fileCode = savedFileName.substring(0, savedFileName.lastIndexOf('.'));

            api.webpartBanner.deleteByCode(fileCode).then((res: any) => {
                if (res && res.length > 0) {

                }
                else {
                    (window as any).alertAsync(this.$t('삭제실패').toString());
                }
            }).finally(() => {
            });
        }
    }

    // 배너추가
    addNewBanner() {
        if (!this.curBanner || this.bannerSetting)
            this.curBanner = this.setBannerInitVal()
        this.bannerSetting = true
    }

    // 배너 저장
    saveBannerSetting() {
        if (this.fileDelete) {
            this.fnDeleteFile();
            this.curBanner.fileName = '';
            this.curBanner.savedFileName = '';
            this.curBanner.filePath = '';
            this.curBanner.fileSize = 0;
        }
        this.curBanner.isGlobal = this.isGlobalBanner
        this.curBanner.mappingId = this.mappingId

        if (this.curBanner.linkUrl.includes('api/processToken')) {
            var url = new URL(this.curBanner.linkUrl)
            var search = url.search
            if (search.indexOf('?', 1) !== -1) {
                var innerParam = search.slice(search.indexOf('?', 1) + 1)
                url.search = url.search.replace(innerParam, encodeURIComponent(innerParam))
            }
            this.curBanner.linkUrl = url.toString()
        }

        api.webpartBanner.addNewBanner(this.curBanner).then(res => {
            if (res && res > 0) {
                (window as any).alertAsync(this.$t('완료').toString())
                this.curBanner = this.setBannerInitVal()
                this.bannerSetting = false
                this.loadBannerList()
            }
            else {
                (window as any).alertAsync(this.$t('추가실패').toString())
            }
        })
    }

    // 배너 수정
    onEditClick(val: number) {
        let selected = this.banners.find(i => i.bannerId == val)
        this.curBanner = selected as webpartBanner.Banner
        this.bannerSetting = true
        this.fileDelete = false
    }

    // 배너 정렬 변경
    moveListOrder(val: number) {
        if (this.selectedBanners.length != 1) return
        let selectIdx = this.banners.findIndex(i => i.bannerId == this.selectedBanners[0].bannerId)
        if ((val < 0 && selectIdx == 0) || (val > 0 && selectIdx == this.banners.length - 1)) return
        api.webpartBanner.updateBannerOrder(this.banners[selectIdx].bannerId as number, val).then(res => {
            if (res && res > 0) {
                this.loadBannerList()
            }
        })
    }

    // 배너 삭제
    async deleteBanner() {
        if (!this.curBanner.bannerId) return
        if (await (window as any).confirmAsync(this.$t('삭제_하시겠습니까').toString())) {
            api.webpartBanner.deleteBannerItem(this.curBanner.bannerId).then(res => {
                if (res) {
                    (window as any).alertAsync(this.$t('삭제_되었습니다').toString())
                    this.loadBannerList()
                }
            })
        }
    }

    // 배너 정렬 설정 저장
    handleSave() {
        if (!this.selectedBanners) return
        else if (this.selectedBanners.length == 0) {
            (window as any).alertAsync('선택된 배너가 없습니다.')
            return
        }
        let setUse: string = '';
        this.selectedBanners.map(i => {
            setUse += i.bannerId + ','
        })
        if (setUse.endsWith(',')) setUse = setUse.slice(0, -1)
        api.webpartBanner.updateBannerList(setUse, this.isGlobalBanner, this.mappingId).then(res => {
            if (res) {
                (window as any).alertAsync(this.$t('저장_하였습니다').toString())
                this.loadBannerList()
            }
        })
    }

    @Watch('selectedBanners')
    selectedLength(val: webpartBanner.Banner[]) {
        if (val && val.length == 1) this.canSetOrder = true
        else this.canSetOrder = false
    }
}